import React, { useState } from 'react';
import { AccordionDetails, Typography, Box, Stack } from '@mui/material';
import { LessonProgressNodes } from 'components/views/myTrainings/LessonProgressNodes/LessonProgressNodes';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LessonProgress } from 'models/LessonProgress';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import {
  StyledAccordion,
  StyledAccordionSummary,
  LessonNameBox,
  UnderlinedTypography,
  PercentageBox,
  StyledLinearProgress,
  PointsBox,
  HistoricalAccordion,
  HistoricalAccordionSummary,
  PointsTypography
} from './LessonProgressAccordion.styles';
import HistoricalProgresses from 'components/views/myTrainings/HistoricalProgresses/HistoricalProgresses';
import { truncateString } from 'helpers/stringHelper';
import { LessonProgressStatus } from "models/LessonProgressStatus";

interface LessonProgressAccordionProps {
    index: number;
    lp: LessonProgress;
    historicalProgresses: LessonProgress[];
    expanded: number | null;
    handleChange: (panel: number) => (event: React.SyntheticEvent) => void;
}

export const LessonProgressAccordion = (props: LessonProgressAccordionProps) => {
  const [hasMounted, setHasMounted] = useState(false);
  const { index, lp, expanded, handleChange } = props;
  const theme = useTheme();
  const { t } = useTranslation();
  
  React.useEffect(() => {
    if (expanded === index) {
      setHasMounted(true);
    }
  }, [expanded, index]);

  const getScoredPoints = () => {
    return !lp.lessonVersion
    ? 0
    : (lp.pointsScored / lp.lessonVersion.maxPoints * 100).toFixed(0)
  }
  
  return (
    <StyledAccordion key={index} expanded={!lp?.createdAt ? false : expanded === index} onChange={handleChange(index)}>
        <StyledAccordionSummary
          aria-controls="panel1d-content"
          id="panel1d-header"
          expandIcon={<ExpandMoreIcon />}
        >
            <Stack direction={'row'} width={'100%'} display={'flex'} justifyContent={'space-between'} paddingLeft={theme.spacing(2)} alignItems={'center'}>
                <LessonNameBox>
                  <UnderlinedTypography>{truncateString(`${lp.lessonVersion.lessonName} (v${lp.lessonVersion.version})`, 25)}</UnderlinedTypography>
                </LessonNameBox>
                                    <PercentageBox sx={{ paddingLeft: theme.spacing(2), paddingRight: theme.spacing(2) }}>
                  <Typography>{getScoredPoints() + ' %'}</Typography>
                </PercentageBox>
                <StyledLinearProgress variant="determinate" value={lp.pointsScored / lp.lessonVersion.maxPoints * 100} />
                <PointsBox>
                    <PointsTypography theme={theme} isCompleted={lp.lessonProgressStatus === LessonProgressStatus.Finished}>
                        {`${lp.pointsScored} / ${lp.lessonVersion.maxPoints}`}
                    </PointsTypography>
                </PointsBox>
            </Stack>
        </StyledAccordionSummary>
        <AccordionDetails>
        {hasMounted && <Stack spacing={theme.spacing(2)}>
          <LessonProgressNodes completedNodes={lp.completedNodes} lessonProgressId={lp.id} isCompleted={lp.lessonProgressStatus === LessonProgressStatus.Finished}/>
          <Box padding={theme.spacing(2)}>
            <HistoricalAccordion elevation={0} disableGutters>
              <HistoricalAccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="historical-progresses-content"
                  id="historical-progresses-header"
              >
                  <Typography>
                      {`${t('myTrainings.historicalProgress.archival')} (${props.historicalProgresses.length})`}
                  </Typography>
              </HistoricalAccordionSummary>
              <HistoricalProgresses historicalProgresses={props.historicalProgresses}/>
          </HistoricalAccordion>
          </Box>
      </Stack>}
        </AccordionDetails>
  </StyledAccordion>
  );
}
